import { beaufortToMetersPerSecondMinValue } from "../../common/converter/wind";
import type { TileLayerConfig } from "./types";

export const windLayerConfig = {
    layerName: "wind",
    layerType: "tile",
    dataSources: {
        eu: {
            nearcast: `/maps/wind/eu/tiles`,
        },
        us: {
            nearcast: `/maps/wind/us/tiles`,
        },
    },
    dataSourcesChannels: {
        permanentlyUnavailable: {
            category: 0,
            colorStops: [
                {
                    value: 0,
                    color: [0, 0, 0],
                },
                {
                    value: 255,
                    color: [0, 0, 0],
                },
            ],
        },
        wind: {
            colorStops: [
                {
                    value: 0,
                    color: [183, 218, 225],
                    descriptionTranslationKey: "wind.calm",
                    treatAsZeroValueStop: true,
                    intensityBarHeightInPercent: 15,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(1),
                    color: [164, 209, 218],
                    descriptionTranslationKey: "wind.lightAir",
                    intensityBarHeightInPercent: 25,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(2),
                    color: [146, 200, 211],
                    descriptionTranslationKey: "wind.lightBreeze",
                    intensityBarHeightInPercent: 35,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(3),
                    color: [107, 184, 199],
                    descriptionTranslationKey: "wind.gentleBreeze",
                    intensityBarHeightInPercent: 45,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(4),
                    color: [68, 167, 187],
                    descriptionTranslationKey: "wind.moderateBreeze",
                    intensityBarHeightInPercent: 55,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(5),
                    color: [219, 224, 93],
                    descriptionTranslationKey: "wind.freshBreeze",
                    intensityBarHeightInPercent: 65,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(6),
                    color: [240, 216, 0],
                    descriptionTranslationKey: "wind.strongWind",
                    intensityBarHeightInPercent: 70,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(7),
                    color: [250, 208, 0],
                    descriptionTranslationKey: "wind.stiffWind",
                    intensityBarHeightInPercent: 75,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(8),
                    color: [253, 191, 78],
                    descriptionTranslationKey: "wind.stormyWind",
                    intensityBarHeightInPercent: 80,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(9),
                    color: [251, 165, 102],
                    descriptionTranslationKey: "wind.storm",
                    intensityBarHeightInPercent: 85,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(10),
                    color: [246, 135, 105],
                    descriptionTranslationKey: "wind.heavyStorm",
                    intensityBarHeightInPercent: 90,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(11),
                    color: [230, 80, 85],
                    descriptionTranslationKey: "wind.hurricaneLikeStorm",
                    intensityBarHeightInPercent: 95,
                },
                {
                    value: beaufortToMetersPerSecondMinValue(12),
                    color: [184, 64, 80],
                    descriptionTranslationKey: "wind.hurricane",
                    intensityBarHeightInPercent: 100,
                },
            ],
        },
    },
} as const satisfies TileLayerConfig;
